/*
 * @Author: WLL
 * @Date: 2020-04-29 14:05:46
 * @LastEditors: WLL
 * @LastEditTime: 2020-05-12 16:48:21
 * @Description: 首页相关接口
 */
import http from "@/utils/http";

export default {
  async getAnalystList() {
    return await http.post("predict/analyst/home/analyst_list", {
      pageNo: 1,
      pageSize: 5,
      V_MONTH: 3,
      V_INDUCODE: "011"
    });
  },
  async getAgencyList() {
    return await http.post("predict/agency/home/agency_list", {
      pageNo: 1,
      pageSize: 5,
      V_MONTH: 3,
      V_INDUCODE: "011"
    });
  },
  async getIndustryList() {
    return await http.post("agency/industry/home/industry_list", {
      pageNo: 1,
      pageSize: 5,
      V_INDUCODE: "011",
      V_MONTH: 1
    });
  },
  async getStockRating() {
    return await http.post("stock/rating", {
      pageNo: 1,
      pageSize: 50,
      V_INDUCODE_H: "011"
    });
  },
  async getIndustryRating() {
    return await http.post("agency/industry/rating", {
      pageNo: 1,
      pageSize: 50,
      V_INDUCODE_H: "011"
    });
  }
};
